import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { App, Form, Spin } from 'antd';
import CardLayout from '../../../layouts/CardLayout';
import { ContractorForm } from '../../../components/Contractor/ContractorForm';
import { CONTRACTOR } from '../../../graphql/queries/contractors';
import { CONTRACTOR_UPDATE } from '../../../graphql/mutations/contractors';
import { ContractorFormValues } from '../../../types/contractor';

const ContractorEdit: React.FC = () => {
  const { id } = useParams();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm<ContractorFormValues>();

  const { data, loading, refetch } = useQuery(CONTRACTOR, {
    variables: { id },
    skip: !id,
  });

  const contractor = data?.contractor;

  useEffect(() => {
    if (contractor) {
      form.setFieldsValue(contractor);
    }
  }, [contractor, form]);

  const [updateContractor, { loading: updating }] = useMutation(CONTRACTOR_UPDATE, {
    onCompleted: result => {
      if (result?.contractorUpdate) {
        message.success('Contractor updated successfully');
        refetch();
      }
    },
    onError: error => {
      message.error(error.message || 'Failed to update contractor');
    },
  });

  if (loading) {
    return <Spin size="large" />;
  }

  if (!contractor) {
    message.error('Contractor not found');
    navigate('/admin/contractors');
    return null;
  }

  const handleFinish = (values: ContractorFormValues) => {
    updateContractor({
      variables: {
        id,
        input: values,
      },
    });
  };

  return (
    <CardLayout>
      <ContractorForm
        form={form}
        loading={updating}
        onFinish={handleFinish}
        submitText="Update Contractor"
        initialValues={contractor}
      />
    </CardLayout>
  );
};

export default ContractorEdit;
